import { Alert } from 'antd'
import ReactMarkdown from 'react-markdown'
import { transformMarkdownUri } from '../../util/commonUtil'

const Message = ({ message }) => {
  if (!message) {
    return null
  }

  const wrapContent = (content) => {
    return <div style={{ marginRight: '40px' }}>{content}</div>
  }

  return (
    <Alert
      className="message"
      message={wrapContent(message.heading)}
      description={wrapContent(<ReactMarkdown children={message.content} transformImageUri={transformMarkdownUri} />)}
      type={message.messageType}
    />
  )
}

export default Message
